module.exports = __webpack_public_path__ + "img/Banner-05.3b79a0a0.png";